import React from 'react';
export function AnnouncementBar() {
  return <div className="w-full bg-gradient-to-r from-blue-900/40 to-purple-900/40 backdrop-blur-md border-b border-white/5 py-2 px-4 text-center relative z-50" data-id="element-76">
      <p className="label-caps text-[10px] md:text-[11px] text-white/80 flex items-center justify-center gap-2 tracking-[0.1em]" data-id="element-77">
        <span className="text-sm" data-id="element-78">🔥</span>
        <span data-id="element-79">
          For creators & entrepreneurs building passive income with YouTube
        </span>
      </p>
    </div>;
}